import { Button, SvgLock, SvgZap, Text, Tooltip } from '@loomhq/lens';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { WORKSPACE_PLAN_BUSINESS } from 'constants/workspacePlans';
import { UPGRADE_TYPES } from 'constants/workspaceUpgradeRequests';
import { getUpgradeRequestStatus, requestUpgrade } from 'creators/upgrades';
import { getTooltipMessage, getUpgradeType } from 'utilities/upgrades';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import styles from './styles.module.less';

const UpgradeButton = ({
  analyticsEvent = null,
  defaultButtonText = null,
  defaultRoleText = null,
  hideIcon = false,
  minPlanForFeature = WORKSPACE_PLAN_BUSINESS,
  hideTooltip = false,
  ...buttonProps
}) => {
  const dispatch = useDispatch();

  const selectedWorkspace = useGetSelectedWorkspace();
  const requestStatus = useSelector(state => state.upgrades.requestStatus);
  const requestStatusFetching = useSelector(state => state.upgrades.fetching);
  const requestStatusFetched = useSelector(state => state.upgrades.fetched);
  const upgradeType = getUpgradeType({ selectedWorkspace, minPlanForFeature });

  useEffect(() => {
    if (!requestStatusFetching && !requestStatusFetched) {
      dispatch(getUpgradeRequestStatus());
    }
  }, [dispatch, requestStatusFetched, requestStatusFetching]);

  const upgradeButton = (
    <Button
      variant="upgrade"
      icon={
        !hideIcon &&
        (upgradeType === UPGRADE_TYPES.ROLE ? <SvgLock /> : <SvgZap />)
      }
      onClick={() =>
        dispatch(
          requestUpgrade({
            analyticsEvent,
            selectedWorkspace,
            minPlanForFeature,
          })
        )
      }
      {...buttonProps}
      className={!hideIcon && styles.iconPadding}
    >
      {upgradeType === UPGRADE_TYPES.ROLE
        ? defaultRoleText || 'Upgrade role'
        : defaultButtonText || 'Upgrade plan'}
    </Button>
  );

  return (
    requestStatusFetched &&
    (hideTooltip ? (
      upgradeButton
    ) : (
      <Tooltip
        keepOpen
        placement="bottomCenter"
        maxWidth={35}
        content={
          <Text size="small">
            {getTooltipMessage({
              selectedWorkspace,
              minPlanForFeature,
              requestStatus,
            })}
          </Text>
        }
      >
        {upgradeButton}
      </Tooltip>
    ))
  );
};

export default UpgradeButton;
